import React from 'react';

export const MiroSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-19.5"
				y="-454.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="#FFDD33" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.0164 7.33325H17.4798L19.5936 11.0472L14.9432 7.33325H12.4067L14.7319 11.8727L9.87008 7.33325H7.3335L9.87008 13.1114L7.3335 24.6666H9.87008L14.7319 12.286L12.4067 24.6666H14.9432L19.5936 11.4605L17.4798 24.6666H20.0164L24.6668 10.2218L20.0164 7.33325Z"
				fill="black"
			/>
		</svg>
	);
};
